'use client';

import { c as _c } from "react/compiler-runtime";
import AnimatedLogo from './AnimatedLogo';

// The factiii brand lockup, shown on the full-screen splash (step 0) and again
// in the right-hand BrandPanel.
//
// GAP: framer's `layoutId="onboardingBrand"` used to glide this from screen
// centre to the side panel as one shared element. CSS has no shared-element
// transition, so the two instances now cross-fade in place instead. See
// .specs/animations.md for the View Transitions plan.
const BrandMark = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="anim-enter relative z-10 flex flex-col items-center [--enter-duration:600ms] [--enter-ease:cubic-bezier(0.5,0,0.2,1)]"><AnimatedLogo /><span className="mt-6 font-display text-[48px] leading-none tracking-tight text-textPrimary">factiii</span><span className="mt-3 text-[15px] text-textSecondary">the internet’s truth layer</span></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default BrandMark;